export const PREDEFINED_MESSAGES = [
  'Bid quickly!',
  'The auction is about to begin.',
  `We're taking a short break, be right back.`,
  'That concludes the auction, thanks for coming!',
];

export const HTML_TAGS_REGEX = /<[^>]+>/g;
